import { render, staticRenderFns } from "./PurchasesTreeTableFilterItem.vue?vue&type=template&id=5cc35290&scoped=true"
import script from "./PurchasesTreeTableFilterItem.vue?vue&type=script&lang=js"
export * from "./PurchasesTreeTableFilterItem.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTreeTableFilterItem.vue?vue&type=style&index=0&id=5cc35290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc35290",
  null
  
)

export default component.exports